export default __webpack_public_path__ + "static/media/redblu-icon-192.a94d31a7.png";